"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
jquery_1["default"].widget('IKS.hallowagtaillink', {
    options: {
        uuid: '',
        editable: null
    },
    populateToolbar: function (toolbar) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var widget = this;
        // eslint-disable-next-line func-names
        var getEnclosingLink = function () {
            var node = widget.options.editable.getSelection().commonAncestorContainer;
            return jquery_1["default"](node).parents('a').get(0);
        };
        var buttonSet = jquery_1["default"]('<span class="' + this.widgetName + '"></span>');
        var addButton = jquery_1["default"]('<span></span>');
        addButton = addButton.hallobutton({
            uuid: widget.options.uuid,
            editable: widget.options.editable,
            label: 'Add/Edit Link',
            icon: 'icon-link',
            command: null,
            queryState: function () {
                return addButton.hallobutton('checked', !!getEnclosingLink());
            }
        });
        addButton.on('click', function () {
            var href;
            var linkType;
            var parentPageId;
            // Defaults.
            var url = window.chooserUrls.pageChooser;
            var urlParams = {
                allow_external_link: true,
                allow_email_link: true,
                allow_phone_link: true,
                allow_anchor_link: true,
            };
            var enclosingLink = getEnclosingLink();
            var lastSelection = widget.options.editable.getSelection();
            if (enclosingLink) {
                href = enclosingLink.getAttribute('href');
                parentPageId = enclosingLink.getAttribute('data-parent-id');
                linkType = enclosingLink.getAttribute('data-linktype');
                urlParams.link_text = enclosingLink.innerText;
                if (linkType === 'page' && parentPageId) {
                    url = window.chooserUrls.pageChooser + parentPageId.toString() + '/';
                }
                else if (href.startsWith('mailto:')) {
                    url = window.chooserUrls.emailLinkChooser;
                    href = href.replace('mailto:', '');
                    urlParams.link_url = href;
                }
                else if (href.startsWith('tel:')) {
                    url = window.chooserUrls.phoneLinkChooser;
                    href = href.replace('tel:', '');
                    urlParams.link_url = href;
                }
                else if (href.startsWith('#')) {
                    url = window.chooserUrls.anchorLinkChooser;
                    href = href.replace('#', '');
                    urlParams.link_url = href;
                }
                else if (!linkType) { /* external link */
                    url = window.chooserUrls.externalLinkChooser;
                    urlParams.link_url = href;
                }
            }
            else if (!lastSelection.collapsed) {
                urlParams.link_text = lastSelection.toString();
            }
            // eslint-disable-next-line no-undef, new-cap
            return ModalWorkflow({
                url: url,
                urlParams: urlParams,
                // eslint-disable-next-line no-undef
                onload: PAGE_CHOOSER_MODAL_ONLOAD_HANDLERS,
                responses: {
                    pageChosen: function (pageData) {
                        var anchor;
                        var linkHasExistingContent;
                        if (enclosingLink) {
                            // Editing an existing link
                            anchor = enclosingLink;
                            linkHasExistingContent = true;
                        }
                        else if (!lastSelection.collapsed) {
                            // Turning a selection into a link
                            anchor = document.createElement('a');
                            lastSelection.surroundContents(anchor);
                            // unlink all previously existing links in the selection,
                            // now nested within 'a'
                            // eslint-disable-next-line func-names
                            jquery_1["default"]('a[href]', anchor).each(function () {
                                var parent = this.parentNode;
                                while (this.firstChild)
                                    parent.insertBefore(this.firstChild, this);
                                parent.removeChild(this);
                            });
                            linkHasExistingContent = true;
                        }
                        else {
                            // Inserting a new link at the cursor position
                            anchor = document.createElement('a');
                            lastSelection.insertNode(anchor);
                            linkHasExistingContent = false;
                        }
                        // Set link attributes
                        anchor.setAttribute('href', pageData.url);
                        if (pageData.id) {
                            anchor.setAttribute('data-id', pageData.id);
                            anchor.setAttribute('data-parent-id', pageData.parentId);
                            anchor.setAttribute('data-linktype', 'page');
                        }
                        else {
                            anchor.removeAttribute('data-id');
                            anchor.removeAttribute('data-parent-id');
                            anchor.removeAttribute('data-linktype');
                        }
                        if (pageData.prefer_this_title_as_link_text || !linkHasExistingContent) {
                            // overwrite existing link content with the returned 'title' text
                            anchor.innerText = pageData.title;
                        }
                        return widget.options.editable.element.trigger('change');
                    }
                }
            });
        });
        buttonSet.append(addButton);
        var cancelButton = jquery_1["default"]('<span></span>');
        cancelButton = cancelButton.hallobutton({
            uuid: widget.options.uuid,
            editable: widget.options.editable,
            label: 'Remove Link',
            icon: 'icon-chain-broken',
            command: null,
            queryState: function () {
                if (!!getEnclosingLink()) {
                    return cancelButton.hallobutton('enable');
                }
                return cancelButton.hallobutton('disable');
            }
        });
        cancelButton.on('click', function () {
            var enclosingLink;
            var sel;
            var range;
            enclosingLink = getEnclosingLink();
            if (enclosingLink) {
                // eslint-disable-next-line no-undef
                sel = rangy.getSelection();
                range = sel.getRangeAt(0);
                range.setStartBefore(sel.anchorNode.parentNode);
                range.setEndAfter(sel.anchorNode.parentNode);
                sel.setSingleRange(range, false);
                document.execCommand('unlink');
                widget.options.editable.element.trigger('change');
            }
        });
        buttonSet.append(cancelButton);
        buttonSet.hallobuttonset();
        toolbar.append(buttonSet);
    }
});
